import { LoadingButton } from "@mui/lab"
import { Box, Button, IconButton, Stack } from "@mui/material"
import { useArticlePreview } from "features/article/preview/container"
import { ArticleResult, useGetArticleLinkOut } from "interface/article"

import { 
  LinkOutIcon, PubMedIcon,
  PreviousIcon, NextIcon
} from 'shared/icons'

type ArticlePreviewFooterProps = {
	article: ArticleResult
	container: ReturnType<typeof useArticlePreview>
}
export const ArticlePreviewFooter = ({
	article,
	container: {
		hasNext, hasPrev,
		openNext, openPrev
	}
}: ArticlePreviewFooterProps) => {
	const linkOutState = useGetArticleLinkOut(article.articleId, { updateTime: article.updateTime })
	return (
		<Stack direction="row" padding={1} spacing={1} alignItems='center' flexWrap='wrap' useFlexGap>
			<LoadingButton
				variant="contained"
				startIcon={<LinkOutIcon />}
				loading={linkOutState.loading}
				disabled={linkOutState.data?.url ? false : true}
				onClick={(event) => {
					event.preventDefault()
					if (linkOutState.data?.url) {
						window.open(linkOutState.data.url, '_blank')
					}
				}}
				color="success"
			>
				原文著書
			</LoadingButton>

			{article.source === 'pubmed' ? (
				<Button
					variant="contained"
					startIcon={<PubMedIcon />}
					disabled={article.url ? false : true}
					onClick={(event) => {
						event.preventDefault()
						if (article.url) {
							window.open(article.url, '_blank')
						}
					}}
				>
					PubMed
				</Button>
			) : <></> }

			<Box sx={{ flexGrow: 1 }} />

			{(hasPrev || hasNext) ? (
				<Stack direction="row" alignItems='center'>
					<IconButton disabled={hasPrev === false} onClick={openPrev}><PreviousIcon/></IconButton>
					<IconButton disabled={hasNext === false} onClick={openNext}><NextIcon/></IconButton>
				</Stack>
			) : <></>}
		</Stack>
	)
}